export default __webpack_public_path__ + "static/media/youtube.87c6fc19.svg";